const useBaseImageUrl = () => {
  return 'https://red-90.com';
};

export default useBaseImageUrl;
